import React, { useState } from "react";
import * as S from "./styles";
import ContactsList from "../contactsList";
import ContactsSearch from "../contactsSearch";
import { IContact } from "../../utils/services/modules/contacts";

interface ContactsProps {
  contacts?: IContact[]; // undefined enquanto o usuário carrega
}

type Tab = "list" | "add";

const ContactsComponent: React.FC<ContactsProps> = ({ contacts }) => {
  const [tab, setTab] = useState<Tab>("list");

  return (
    <S.Container>
      <S.TabContainer role="tablist">
        <S.TabButton
          type="button"
          role="tab"
          aria-selected={tab === "list"}
          $active={tab === "list"}
          onClick={() => setTab("list")}
        >
          <S.ListContactsIcon />
          Meus contatos
          {!!contacts?.length && (
            <S.Count $active={tab === "list"}>{contacts.length}</S.Count>
          )}
        </S.TabButton>
        <S.TabButton
          type="button"
          role="tab"
          aria-selected={tab === "add"}
          $active={tab === "add"}
          onClick={() => setTab("add")}
        >
          <S.AddContactsIcon />
          Adicionar
        </S.TabButton>
      </S.TabContainer>

      {tab === "list" ? (
        <ContactsList contacts={contacts} onAddContact={() => setTab("add")} />
      ) : (
        <ContactsSearch onShowContacts={() => setTab("list")} />
      )}
    </S.Container>
  );
};

export default ContactsComponent;
